import { render, staticRenderFns } from "./glob.vue?vue&type=template&id=607aa54f&scoped=true"
import script from "./glob.vue?vue&type=script&lang=js"
export * from "./glob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607aa54f",
  null
  
)

export default component.exports